export enum ImageContentStyle {
  WINDOW_WIDTH = 0,
  CONTENT_WIDTH = 1,
  TEXT_WIDTH = 2,
  HALF_CONTENT_WIDTH = 3,
  ORIGINAL_WIDTH = 4,
}
